module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"Contact <br> us"},"fr":{"all":"Nous <br> contacter"}}')
  delete Component.options._Ctor
}
